module.exports = __webpack_public_path__ + "img/5-3.bf87e6c1.png";